<pn-dialog-card
    title="Thông tin chi tiết"
    containerClass="w-[666px] mb:w-full mb:!rounded-b-none"
    headerClass="!pb-2"
    i18n-title="@@notification.labels.detail"
    actionClass="justify-end flex-row-center mb:grid mb:grid-cols-1 w-full"
    bodyClass="flex flex-col gap-3 !pb-0"
    (close)="close()"
>
    <p class="flex flex-row flex-wrap gap-1 text-base text-neutral-06">
        <span class="text-base text-neutral-06" i18n="@@notification.labels.title">Tiêu đề:</span>
        <span class="font-lato-semibold font-semibold text-neutral-07">{{ data.Title }}</span>
    </p>
    <p class="text-base text-neutral-06">
        <span class="text-base text-neutral-06" i18n="@@notification.labels.content">
            Nội dung:
        </span>
        <strong
            class="font-lato-semibold font-semibold text-neutral-07"
            [innerHTML]="content"
        ></strong>
    </p>

    <button
        pnButton
        link
        size="tiny"
        class="w-fit gap-1 !px-1 flex-row-center"
        *ngIf="isShowInteract"
        (click)="interactNotification()"
    >
        <svg-icon src="/assets/icons/file-1.svg" svgClass="size-4" />
        <span i18n="@@notification.labels.order-detail" class="font-lato-bold text-sm font-bold">
            Chi tiết đơn hàng
        </span>
    </button>

    <ng-template pnTemplate="action">
        <button class="w-[146px] !font-bold mb:w-full" pnButton rounded="lg" (click)="close()">
            Đóng
        </button>
    </ng-template>
</pn-dialog-card>
